import urlRegex from 'utils/url-regex'

export const linkifyUrls = string =>
  string.replace(
    urlRegex({ strict: false }),
    match =>
      `<a href="${
        match.startsWith('http') ? match : 'http://' + match
      }" target="_blank">${match}</a>`
  )



// WEBPACK FOOTER //
// ./src/utils/index.js